import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useLenisPause } from "@/components/invite/RsvpModal";
import { photoSrc } from "@/lib/api";

export default function Lightbox({ photos, index, setIndex }) {
  const open = index >= 0 && index < photos.length;
  useLenisPause(open);
  const p = open ? photos[index] : null;
  const go = (d) => setIndex((i) => (i + d + photos.length) % photos.length);
  const onKey = (e) => {
    if (e.key === "ArrowRight") go(1);
    if (e.key === "ArrowLeft") go(-1);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && setIndex(-1)}>
      <DialogContent onKeyDown={onKey} className="flex h-[100dvh] max-h-[100dvh] w-screen max-w-none flex-col items-center justify-center rounded-none border-0 bg-[#142344]/95 p-4 text-[var(--ivory)] sm:p-10 [&>button]:text-[var(--ivory)] [&>button]:opacity-100" data-testid="lightbox">
        <DialogTitle className="sr-only">Photo viewer</DialogTitle>
        <DialogDescription className="sr-only">Use the arrow keys or buttons to move between photos.</DialogDescription>
        {p && (
          <figure className="flex max-h-full w-full flex-col items-center">
            <img src={photoSrc(p.id)} alt={p.caption || "A memory from the courtyard"} className="max-h-[78dvh] max-w-full rounded-[4px] object-contain" />
            {(p.caption || p.display_name) && (
              <figcaption className="mt-3 text-center text-[#EADFC6]">
                {p.caption} {p.display_name && <span className="text-sm">by {p.display_name}</span>}
              </figcaption>
            )}
          </figure>
        )}
        {photos.length > 1 && (
          <div className="mt-4 flex gap-4">
            <button type="button" onClick={() => go(-1)} className="btn-ghost border-[rgba(255,247,232,.5)] bg-transparent text-[var(--ivory)] hover:bg-white/10" aria-label="Previous photo" data-testid="lightbox-prev"><ChevronLeft className="h-5 w-5" /></button>
            <span className="self-center text-sm">{index + 1} / {photos.length}</span>
            <button type="button" onClick={() => go(1)} className="btn-ghost border-[rgba(255,247,232,.5)] bg-transparent text-[var(--ivory)] hover:bg-white/10" aria-label="Next photo" data-testid="lightbox-next"><ChevronRight className="h-5 w-5" /></button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
